import styles from "./user-name.module.css";

interface UserNameProps {
  children: React.ReactNode;
}

export default function UserName({ children }: UserNameProps) {
  return (
    <div data-testid="user-name" className={styles.userName}>
      {children}
    </div>
  );
}
